import { view, anodum } from '@yola/ws-sdk';
import createCompositeItem from './create-composite-item';
import calculateNewItemPosition from './calculate-new-item-position';
import selectors from '../constants/selectors';
import common from '../constants/common';

function addCompositeItem({ elementId }) {
  const liveNode = view.accessors.getLiveElement(elementId);
  let targetLiveNode = liveNode;

  if (anodum.isTag(liveNode, selectors.COMPOSITE_ITEM)) {
    targetLiveNode = liveNode.closest(selectors.COMPOSITE_GROUP);
  }

  const { height } = targetLiveNode.getBoundingClientRect();
  const targetElementId = view.accessors.getLiveElementId(targetLiveNode);
  const compositionGroup = view.accessors.getStaticElement(targetElementId);
  const newCompositionItem = createCompositeItem({
    position:
      height < common.DEFAULT_MEDIA_SIZE ? '50% 0%' : calculateNewItemPosition(compositionGroup),
  });

  compositionGroup.appendChild(newCompositionItem);

  view.operations.replaceElement(compositionGroup, targetElementId);
}

export default addCompositeItem;
